import { FC, memo } from 'react';
import classNames from 'classnames';

import { PlayerSupportedFeatures } from 'application/pages/constants';

import IconHelpCircle from '@zvuk-b2b/react-uikit/ui/icons/HelpCircle';

import { getStreamDescription, getPlayerDescription } from './utils';
import { PointItemContentType } from './types';
import { TEXTS } from './texts';

import styles from './index.module.scss';

const ItemContent: FC<PointItemContentType> = ({
  className,
  showStreamData,
  showVideoStreamData,
  isLoading,
  currentItem,
  showHint,
  hintIconNearSelector = false,
  disabled,
}) => {
  const showStream = showStreamData || showVideoStreamData;
  const isVideoSupport = currentItem?.device?.supportedFeatures.includes(PlayerSupportedFeatures.VideoSupport);

  return (
    <div className={classNames(styles.content, showStream && styles.fullContent, className)}>
      <strong
        data-loading={isLoading}
        className={classNames(styles.title, {
          [styles.titleDisabled]: disabled,
        })}>
        {!isLoading && (currentItem?.title || currentItem?.address)}
      </strong>

      {showStream && (
        <>
          <span
            data-loading={isLoading}
            className={classNames(styles.secondaryText, {
              [styles.secondaryTextDisabled]: disabled,
            })}>
            {!isLoading &&
              currentItem &&
              getStreamDescription(
                showVideoStreamData ? currentItem.videoStream?.title : currentItem.stream?.title,
                showVideoStreamData
              )}
          </span>

          <span
            data-loading={isLoading}
            className={classNames(styles.secondaryText, {
              [styles.secondaryTextDisabled]: disabled,
              [styles.secondaryTextWarning]: !currentItem?.device || (showVideoStreamData && !isVideoSupport),
            })}>
            {!isLoading && (
              <>
                {`${TEXTS.DEVICE_TYPE}: `}
                {currentItem && getPlayerDescription(currentItem.device?.type, showVideoStreamData, isVideoSupport)}
              </>
            )}
          </span>
        </>
      )}

      {showHint && (
        <span
          id="point_item_content_hint"
          className={styles.popperWrapper}>
          <IconHelpCircle
            className={classNames({
              [styles.popperWrapperIcon]: hintIconNearSelector,
            })}
          />
        </span>
      )}
    </div>
  );
};

export default memo(ItemContent);
